import { DOMAIN_COUNTRY_MAP } from 'constants/domainConfig'
import { DOMAIN } from 'constants/base'

import { isEmpty, path, resolveKeysInObjectsArrays } from 'utils/browserHelper'
import { sendClevertapUIActionEvent as ClevertapEvent } from 'utils/globalNav/unifiedLogin'

export const normalizeSize = size => {
    if (typeof size === 'number') return `${size}px`
    return `${size}`
}

export const getPopularDestinationUrl = page_url => {
    if (isEmpty(page_url)) return null
    const today = new Date()
    const d1 = new Date(today.getTime() + 3 * 24 * 60 * 60 * 1000)
    const d2 = new Date(today.getTime() + 4 * 24 * 60 * 60 * 1000)
    const dd = String(d1.getDate()).padStart(2, '0')
    const nextDD = String(d2.getDate()).padStart(2, '0')
    const m1 = String(d1.getMonth() + 1).padStart(2, '0') //January is 0!
    const m2 = String(d2.getMonth() + 1).padStart(2, '0')
    const y1 = d1.getFullYear()
    const y2 = d2.getFullYear()
    return page_url.replace('{@checkin}', dd + '/' + m1 + '/' + y1).replace('{@checkout}', nextDD + '/' + m2 + '/' + y2)
}

export const isFeatureEnabled = () => {
    const data = window.offerJson || []
    let currentTime = new Date()

    let currentOffset = currentTime.getTimezoneOffset()

    let ISTOffset = 330 // IST offset UTC +5:30

    let ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000)

    // let obj = {
    //     a: {
    //         bbdBannerEnabled: true,
    //         popularDestinationEnabled: true
    //     },
    //     b: {
    //         bbdBannerEnabled: true,
    //         popularDestinationEnabled: false
    //     },
    //     c: {
    //         bbdBannerEnabled: false,
    //         popularDestinationEnabled: true
    //     },
    //     d: {
    //         bbdBannerEnabled: true,
    //         popularDestinationEnabled: true
    //     }
    // }
    // let expConfig = getCookie('exp') || 'a'
    if (DOMAIN_COUNTRY_MAP[DOMAIN] === 'IN') {
        let obj = {}
        for (let index = 0; index < data.length; index++) {
            let config = data[index]
            if (new Date(config.time.from) <= ISTTime && new Date(config.time.to) >= ISTTime) {
                obj = { ...config }
                break
            }
        }
        return obj
    } else {
        return { travelsafeEnabled: true }
    }
}

export const hotelSearchDisable = () => {
    let currentTime = new Date()
    let currentOffset = currentTime.getTimezoneOffset()
    let ISTOffset = 330 // IST offset UTC +5:30
    let ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000)
    let saleTime = ISTTime.toLocaleTimeString()

    const fromTime = '11:45:00'
    const toTime = '12:30:00'

    if (saleTime >= fromTime && saleTime <= toTime) {
        return true
    }

    return false
}

export const getPlatformApiDomain = () => {
    const domain = window.location.hostname
    switch (domain) {
        case 'localhost':
            return 'https://platformqa2new.cleartrip.com'
        // case 'www.cleartrip.com':
        //     return 'https://platform.cleartrip.com'
        // case 'qa2.cleartrip.com':
        //     return 'https://platformqa2.cleartrip.com'
        // case 'qa2new.cleartrip.com':
        //     return 'https://platformqa2new.cleartrip.com'
        default:
            return ''
    }
}
export const getApiDomain = () => {
    switch (window.location.hostname) {
        case 'localhost': {
            return 'https://qa2.cleartrip.com'
        }
        case 'qa2.cleartrip.com': {
            return 'https://qa2.cleartrip.com'
        }
        default: {
            return window.location.origin
        }
    }
}

export const checkInDomain = () => {
    let isInDomain = false
    let domain = path(['location', 'hostname'], window)
    if (
        domain === 'www.cleartrip.com' ||
        domain === 'qa2.cleartrip.com' ||
        domain === 'qa2new.cleartrip.com' ||
        domain === 'localhost' ||
        domain === '0.0.0.0'
    ) {
        isInDomain = true
    }
    return isInDomain
}
export const clevertapUtil = payload => {
    const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)
    const pathname = query && query.split('/')
    const pagePath = pathname[2]
    ClevertapEvent({
        ...payload,
        page:
            pagePath === 'results'
                ? 'SRP'
                : isEmpty(pagePath)
                ? 'HP'
                : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                ? 'Itinerary'
                : 'Confirmation_Page'
    })
}
